var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('ButtonGeneric', _vm._g(_vm._b({
    attrs: {
      "color": _vm.computedColor,
      "disabled": _vm.computedDisabled,
      "href": _vm.href,
      "icon": _vm.computedIcon,
      "show-loader": _vm.showLoader === true || _vm.isSaving === true,
      "text-color": _vm.computedTextColor,
      "loading-text": "Saving…"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_vm._t("icon")];
      },
      proxy: true
    }], null, true)
  }, 'ButtonGeneric', {
    ..._vm.$attrs,
    ..._vm.$props
  }, false), _vm.$listeners), [_vm.$slots.default ? _vm._t("default") : [_vm._v("Create")]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };